/**
 * @generated SignedSource<<4a1ae648152a21402353ca4e0b784fa7>>
 * @relayHash 16d1d57ae1e077646b323c7bbc3bad59
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7fb23c7f2aba6df5130f600555e369c4b607e1780f8a32632caff7b58f9f1172

import type { ConcreteRequest, Query } from 'relay-runtime';
export type CatchupContentType = "BLOGPOST" | "PAGE" | "%future added value";
export type useIsEligibleForContextualCollabOnboardingLastViewedTimeQuery$variables = {
  contentId: string;
  contentType: CatchupContentType;
};
export type useIsEligibleForContextualCollabOnboardingLastViewedTimeQuery$data = {
  readonly catchupGetLastViewedTime: {
    readonly lastViewedTimeISO: string | null | undefined;
  } | null | undefined;
};
export type useIsEligibleForContextualCollabOnboardingLastViewedTimeQuery = {
  response: useIsEligibleForContextualCollabOnboardingLastViewedTimeQuery$data;
  variables: useIsEligibleForContextualCollabOnboardingLastViewedTimeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentType"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "contentType",
        "variableName": "contentType"
      }
    ],
    "concreteType": "CatchupLastViewedTimeResponse",
    "kind": "LinkedField",
    "name": "catchupGetLastViewedTime",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "lastViewedTimeISO"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useIsEligibleForContextualCollabOnboardingLastViewedTimeQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useIsEligibleForContextualCollabOnboardingLastViewedTimeQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "16d1d57ae1e077646b323c7bbc3bad59",
    "id": "7fb23c7f2aba6df5130f600555e369c4b607e1780f8a32632caff7b58f9f1172",
    "metadata": {},
    "name": "useIsEligibleForContextualCollabOnboardingLastViewedTimeQuery",
    "operationKind": "query",
    "text": "query useIsEligibleForContextualCollabOnboardingLastViewedTimeQuery($contentId:ID!,$contentType:CatchupContentType!){catchupGetLastViewedTime(contentId:$contentId,contentType:$contentType){lastViewedTimeISO}}"
  }
};
})();

(node as any).hash = "a4001dbd2f62afbd44c030e7810effa8";

export default node;
